// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".question-answer{display:flex;flex-wrap:wrap}.question-answer .question{width:100%;cursor:pointer;display:flex;justify-content:space-between}.question-answer .question-text{flex:1}.question-answer .question-icon{display:flex;justify-content:center;align-items:center}.question-answer .answer{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
